import React from 'react'

interface TcccIconProps {
  className?: string
  style?: React.CSSProperties
  width?: number | string
  height?: number | string
}

const TcccIcon: React.FC<TcccIconProps> = ({
  className = 'MuiSvgIcon-root MuiSvgIcon-fontSizeMedium tccc-bo7eq',
  style = {},
  width = 36,
  height = 36
}) => {
  return (
    <svg
      className={className}
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 36 36"
      width={width}
      height={height}
      style={style}
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect fill="#FFFFFF" x="0" y="0" width="36" height="36" rx="4"></rect>
        <path
          d="M26.7500049,16.3749332 C26.0000547,12.1249823 22.3750317,9 18.0000781,9 C13.6249487,9 10.0000625,12.2500027 9.24997559,16.3749137 C8.49998633,16.999957 8,18.1250038 8,19.2499724 C8,20.7499631 8.87499072,22.4999556 10.2500068,22.4999556 C11.4999629,22.4999556 11.4999629,21.1249852 11.4999629,19.2499724 C11.4999629,17.49998 11.4999629,16.1249706 10.6250112,15.9999502 C11.3749419,12.6249857 14.3750356,10.1249686 18.0000781,10.1249686 C21.6249644,10.1249686 24.6250386,12.6249857 25.3750083,15.8750275 C24.5000176,16.1249901 24.5000176,17.3749596 24.5000176,19.1249325 C24.5000176,20.3636519 24.5000176,21.2340485 24.743204,21.8578223 C24.7454306,21.863545 24.7512119,21.8689356 24.7499619,21.8749318 C24.041731,25.2304625 22.0000469,26.6249642 19.9999844,27.1250067 C19.625019,26.6249642 18.8750298,26.2500203 18.0000586,26.2500203 C16.7499268,26.2500203 15.7499932,26.8750245 15.7499932,27.6249906 C15.7499932,28.3750739 16.7499268,29 18.0000586,29 C19.2500146,29 20.2500264,28.3750739 20.2500264,27.6249906 C22.2500107,27.1250067 24.6667383,25.399741 25.1250444,22.2498953 C25.1242632,22.2552664 25.1328375,22.2574734 25.1369196,22.2610672 C25.265339,22.3749352 25.5077052,22.3749352 25.7499932,22.3749352 C27.1249897,22.3749352 28,20.6249232 28,19.124913 C28,18.1250038 27.5,16.999957 26.7500049,16.3749332 Z"
          fill="#006EFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}

export default TcccIcon
